import { QUICK_NOTES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const quickNotesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getQuickNotes: build.query({
      query: (params = {}) => ({
        url: QUICK_NOTES.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('QuickNote', result),
    }),
    getQuickNoteById: build.query({
      query: (id) => ({ url: QUICK_NOTES.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'QuickNote', id }],
    }),
    createQuickNote: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: QUICK_NOTES.LIST,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'QuickNote', id: 'LIST' }],
    }),
    updateQuickNote: build.mutation({
      query: ({ id, data: updateData, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: QUICK_NOTES.BY_ID(id),
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
    deleteQuickNote: build.mutation({
      query: (id) => ({ url: QUICK_NOTES.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
    markAsPin: build.mutation({
      query: (id) => ({
        url: QUICK_NOTES.MARK_AS_PIN(id),
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
    unmarkAsPin: build.mutation({
      query: (id) => ({
        url: QUICK_NOTES.UNMARK_AS_PIN(id),
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
    markAsComplete: build.mutation({
      query: (id) => ({
        url: QUICK_NOTES.MARK_AS_COMPLETE(id),
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
    unmarkAsComplete: build.mutation({
      query: (id) => ({
        url: QUICK_NOTES.UNMARK_AS_COMPLETE(id),
        method: 'POST',
      }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'QuickNote', id },
        { type: 'QuickNote', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetQuickNotesQuery,
  useLazyGetQuickNotesQuery,
  useGetQuickNoteByIdQuery,
  useLazyGetQuickNoteByIdQuery,
  useCreateQuickNoteMutation,
  useUpdateQuickNoteMutation,
  useDeleteQuickNoteMutation,
  useMarkAsPinMutation,
  useUnmarkAsPinMutation,
  useMarkAsCompleteMutation,
  useUnmarkAsCompleteMutation,
} = quickNotesApi;
